import React, { useState } from 'react'
import ContextMenu, {
  type ContextMenuState,
  type MenuItem,
} from '../../common/ContextMenu.tsx'
import { createPortal } from 'react-dom'
import useUiStore from '../../../shared/store/ui.store.tsx'
import useTracksStore from '../../../shared/store/tracks.store.tsx'

export interface TrackProps {
  trackId: string
}

interface TrackContainerProps {
  contextMenuVM?: MenuItem[]
  children?: React.ReactNode
}

const TrackContainer = React.forwardRef<HTMLDivElement, TrackContainerProps>(
  ({ contextMenuVM, children }, ref) => {
    const pixelsPerSecond = useUiStore((state) => state.pixelsPerSecond)
    const divisionsPerSecond = useTracksStore(
      (state) => state.divisionsPerSecond
    )
    const [contextMenuState, setContextMenuState] = useState<ContextMenuState>({
      isOpen: false,
      position: { left: 0, top: 0 },
    })

    return (
      <>
        <div
          onContextMenu={(e) => {
            e.preventDefault()
            setContextMenuState({
              isOpen: true,
              position: { left: e.clientX + 2, top: e.clientY },
            })
          }}
          ref={ref}
          className="relative h-[134px] w-full border-b border-r border-b-gray-800 border-r-[#4e4e4e]"
          style={{
            backgroundImage: `repeating-linear-gradient(
          to right,
          rgba(255, 255, 255, 0.1),
          rgba(255, 255, 255, 0.1) 1px,
          transparent 1px,
          transparent ${pixelsPerSecond / divisionsPerSecond}px
        )`,
          }}
        >
          {children}
        </div>
        {contextMenuState.isOpen &&
          contextMenuVM &&
          createPortal(
            <ContextMenu
              isOpen={contextMenuState.isOpen}
              setIsOpen={(isOpen: boolean) =>
                setContextMenuState((prev) => ({ ...prev, isOpen }))
              }
              position={contextMenuState.position}
              viewModel={contextMenuVM}
            />,
            document.body
          )}
      </>
    )
  }
)

TrackContainer.displayName = 'TrackContainer'
export default TrackContainer
